import React from "react";
import { useEffect, useState } from "react";
import { Card, Form, ListGroup } from 'react-bootstrap'
import { Button, Icon, Item, Label, ListItem, List, ListHeader} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { Toast } from "./Toast";


const SummaryCart = ({ cart, totalItem, totalPrice, voucher, url, label, customerAddress, setModalPayment, page, courier, showModalmodalVoucher, setCart, completeSelectedCourier, isUpdate, isPickUp = false, setModalPickUp, setMainEnableButton, pendingCourier = '' }) => {
    const navigate = useNavigate(); 
    const idCustomer = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const [shippingCost, setShippingCost] = useState(0)
    const token = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')).token : null
    const [load, setLoad] = useState(false)

    // let shippingCost = (cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0 && parseFloat(courier.service.price) > parseFloat(cart.summary.voucher_ongkir)) ? 
    // (courier) ? (courier.service) ? parseFloat(courier.service.price) - parseFloat(cart.summary.voucher_ongkir) : (cart.summary.service_cost > 0) ? parseFloat(cart.summary.service_cost) - parseFloat(cart.summary.voucher_ongkir): 0 : 0 :
    // (courier) ? (courier.service) ? parseFloat(courier.service.price) : parseFloat(cart.summary.service_cost) : 0 

    const calcShippingCost = () => {
        if (courier !== null && typeof courier.service !== 'undefined'){
            let shipCost = parseFloat(courier.service.price)
            let dscOngkir = cart.summary.voucher_ongkir 

            if (shipCost > dscOngkir){
                setShippingCost(shipCost - dscOngkir)
            } else {
                setShippingCost(shipCost - shipCost)
            }
        } 
    }

    const updateQty = () => {
        let param = cart.products
        
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php/?index=5`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization':token
            },
            data : param
        })
        .then(res => { 
            
        })
    }

    const createOrder = (data) => { 
        setMainEnableButton(false)
        setLoad(true)
        data.summary.date = moment().format('YYYY-MM-DD H:m:s')
        const param = new URLSearchParams()
        //HEADER PARAM
        param.append('id_customer' , idCustomer)
        param.append('selected_voucher', JSON.stringify(data.selected_voucher))
    
        axios ({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php/?index=1`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization' : token
            },
            data : param
        })
        .then(response => { 
            if (response.data.state === 200){ 
                setMainEnableButton(true)
                setLoad(false)
                cart.summary.expiry_time =response.data.expiry_time
                cart.summary.order_id = response.data.order_id
                cart.is_ordered = 1 //UBAH STATE ORDER JADI 1
                cart.products = response.data.cart_product
                // updateQty()
                setCart(cart)
                navigate(url)
            }else if (response.data.state === 500){
                setMainEnableButton(true)
                //console.log(response.data)
                alert(
                    `Order failed: ${response.data.message}\n` +
                    (response.data.updateCartError ? `Cart Error: ${response.data.updateCartError}\n` : '') +
                    (response.data.rollbackCartProduct ? `Rollback: ${response.data.rollbackCartProduct}` : '')
                )

                // alert(response.data.message + ' ' + response.data?.updateCartError + ' ' + response.data?.rollbackCartProduct)
            }else{
                setMainEnableButton(true)
                alert('Create order failed')
            }
        })
    }

    // useEffect(() => {
    //     createOrder(cart)
    // },[cart])

    useEffect(() => {
        calcShippingCost()
    }, [courier])

    
    return (
        <section>
            <Card className='text-start'>
                <ListGroup variant="flush" className="">
                    {
                        (label !== 'Select Payment') ? ( (cart.is_ordered == 0 || !cart.hasOwnProperty('is_ordered')) &&
                            <ListGroup.Item className="p-3">
                                <Button disabled={
                                    load ? true :
                                    !isUpdate && isPickUp ? false :
                                        isUpdate ? true 
                                        : (cart.is_ordered == 0) ?  false 
                                            : (page === 'cart' && cart.hasOwnProperty('is_ordered')) ? true 
                                                : false
                                }
                                color="orange" content="Shopping with voucher" labelPosition='right' icon="right arrow" fluid size="large" basic onClick={() => showModalmodalVoucher()}/>
                            </ListGroup.Item>
                        ) : (<></>)
                    }

                    <ListGroup.Item className="p-3">
                        <h4><Icon name="shopping cart" color="orange"/>&nbsp;Summary</h4>
                        <div className='d-flex justify-content-between'>
                            <div>Total ({totalItem} item's): </div>
                            <div>{global.IDR.format(totalPrice)}</div>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <div>Voucher: </div>
                            <div style={{color:'#FF5733'}}>-{global.IDR.format(cart.summary.voucher)}</div>
                        </div>
                        {/* <div className='text-secondary'>
                            Shipping Details:
                            <div className='d-flex flex-column'>
                                {Object.entries(detailCourier).map(([key, value], i) => (
                                    <div className='d-flex justify-content-between' key={i}>
                                        <div>{`${value.alias} - ${value.service_display === null ? 'No Service' : value.service_display}:`}</div>
                                        <div>{`${global.IDR.format(value.price)}`}</div>
                                    </div>
                                ))}
                            </div>
                        </div> */}
                        {!isPickUp && (
                        <>
                            <div className='d-flex justify-content-between'>
                                <div>Shipping: </div>
                                <div>{global.IDR.format(shippingCost)} {cart.summary.voucher_ongkir && cart.summary.voucher_ongkir > 0  ? <span style={{color:'#FF5733'}}>(-{global.IDR.format(cart.summary.voucher_ongkir)})</span> : <></>}</div>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <div>Shipping Insurance: </div>
                                <div>{global.IDR.format(cart.summary.asuransi)}</div>
                            </div>
                        </>
                        )}
                        <hr />
                        <div className='d-flex justify-content-between'>
                            <div className="fw-bold">Grand Total:</div>
                            <div><Label color="orange">{global.IDR.format((totalPrice + shippingCost) + cart.summary.asuransi - cart.summary.voucher)}</Label></div>
                        </div>

                        
                        {/* Disclaimer */}
                        <Card
                        className="mt-4 mb-4"
                        style={{
                            backgroundColor: '#FFF8E8',
                            border: '1px solid #F1D7A0',
                            borderRadius: '12px',
                        }}
                        >
                            <Card.Body>
                                <Card.Title style={{ color: '#805000', fontSize: '16px', fontWeight: 'bold' }}>
                                    <Icon
                                        name="info circle"
                                        style={{
                                        color: '#805000',
                                        fontSize: '18px',
                                        margin: 0,
                                        }}
                                    /> Disclaimer
                                </Card.Title>

                                <Card.Text 
                                    style={{
                                        color: '#705B35',
                                        fontSize: '13px',
                                        lineHeight: '1.6',
                                        textAlign: 'justify',
                                    }}
                                >
                                    Discounted and Bundled Items Are Final Sale. These Items Cannot Be Refunded or Exchanged for Different Products.
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <div className="mt-4">
                            <Button
                                loading={load}
                                labelPosition="right"
                                icon="arrow alternate circle right outline"
                                content={isUpdate && (isUpdate && !isPickUp) ? pendingCourier !== '' ? pendingCourier : 'Please Wait...' : label}
                                color="black"
                                fluid
                                size="large"
                                disabled={
                                    !isUpdate && isPickUp ? false :
                                        isUpdate ? true 
                                        : (cart.is_ordered == 0) ?  false 
                                            : (page === 'cart' && cart.hasOwnProperty('is_ordered')) ? true 
                                                : false
                                }
                                onClick={() => {
                                    if (parseInt(totalPrice) > 20000 && totalPrice != null && typeof totalPrice != 'undefined'){
                                        if (url !== null) { // CART
                                            createOrder(cart)
                                        } else if (setModalPayment !== null && page === 'checkout') { // CHECKOUT
                                            if(isPickUp) {
                                                setModalPickUp(true)    
                                            } else {
                                                if (customerAddress !== null) { 
                                                    //console.log(courier)
                                                    if (completeSelectedCourier) { 
                                                        setModalPayment(true)
                                                    } else {
                                                        // alert('Please select one courier')
                                                        alert('Please select all courier')
                                                    }
                                                } else if (customerAddress == null) {
                                                    alert('Address cannot be empty')
                                                } else if (courier == null) {
                                                    alert('Courier cannot be empty')
                                                }
                                            }
                                        }

                                        if (url == null && setModalPayment == null && page === 'cart') {
                                            alert("If you haven't added any products to your shopping cart yet, please select a product first")
                                        }
                                    } else {
                                        Toast.fire({
                                            icon: "error",
                                            text : "there`s error : Item price too low, you can cancel this order, and try to place order again",
                                            position:'center'
                                        })
                
                                    }
                                }}
                            />
                        </div>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        </section>
    )
}

export default SummaryCart;